import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { logout, logoutAll } from './api';
import { clearRecoveryCodes } from './recovery-store';
import { AUTH_STATE_KEY } from './useAuthState';

/** Signs out (this device, or every device) and goes to the sign-in screen. */
export function useSignOut() {
  const client = useQueryClient();
  const navigate = useNavigate();

  return async function signOut(everywhere = false) {
    try {
      await (everywhere ? logoutAll() : logout());
    } finally {
      clearRecoveryCodes();
      client.removeQueries({ predicate: (q) => q.queryKey[0] !== AUTH_STATE_KEY[0] });
      await client.invalidateQueries({ queryKey: AUTH_STATE_KEY });
      await navigate({ to: '/sign-in' });
    }
  };
}
